import { RightIcon } from 'foundations-assets';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TranslateTemplateNavItem(props) {
  const {
    title,
    onClick
  } = props;
  return /*#__PURE__*/_jsx(View, {
    borderBlockStartWidth: "100",
    borderBlockStartStyle: "solid",
    borderBlockStartColor: "border-core-default",
    children: /*#__PURE__*/_jsx(SideNavItem, {
      paddingBlock: "400",
      paddingInline: "700",
      onClick: onClick,
      title: /*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "body-200",
        children: title
      }),
      iconRight: /*#__PURE__*/_jsx(RightIcon, {
        size: "400",
        color: "text-interactive-default"
      })
    })
  });
}